<template>
<div>
  <ul v-for="region in regions" v-bind:key="region.RegionId">
    <li @click="toggleOpen(region)" class="list-region clickable">
      <i v-if="!region.open" class="material-icons">arrow_right</i>
      <i v-if="region.open" class="material-icons">arrow_drop_down</i>
      {{region.Name}}
      <span v-bind:class="{'extended-opacity': region.open}">
        <span class="error-count alarm-text">{{region.error.length}}</span><span class="warning-count warning-text">{{region.warning.length}}</span><span class="maintenance-count maintenance-text">{{region.maintenance.length}}</span><span class="total-count">{{region.error.length+region.warning.length+region.maintenance.length+region.normal.length+region.unknown.length}} {{ $t('views.alarmlist.railobjects') }}</span>
      </span>
    </li>
    <table class="noselect hierarchy-list striped highlight" v-if="region.open">
      <thead>
        <tr class="clickable">
          <th v-show="region.columns.path.visible" @click="toggleSort('path', region)">{{ $t('views.alarmlist.path') }}
            <i v-show="region.columns.path.sort === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
            <i v-show="region.columns.path.sort === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
          </th>
          <th class="severity-column" v-show="region.columns.severity.visible" @click="toggleSort('severity', region)">{{ $t('views.alarmlist.severity') }}
            <i v-show="region.columns.severity.sort === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
            <i v-show="region.columns.severity.sort === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
          </th>
          <!-- <th class="objecttype-column" v-show="region.columns.objecttype.visible" @click="toggleSort('objecttype', region)">{{ $t('views.alarmlist.typeofobject') }}
            <i v-show="region.columns.objecttype.sort === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
            <i v-show="region.columns.objecttype.sort === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
          </th> -->
          <th class="date-column" v-show="region.columns.date.visible" @click="toggleSort('date', region)">{{ $t('views.alarmlist.date') }}
            <i v-show="region.columns.date.sort === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
            <i v-show="region.columns.date.sort === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="clickable" v-for="railObject in region.sorted.slice(region.listIndex*itemsPerPage, (region.listIndex*itemsPerPage)+itemsPerPage)" v-bind:key="railObject.RailObjectId" v-on:click="showDetail(railObject)">
          <td v-show="region.columns.path.visible" class="alarm-list-switch">{{railObject.path}}</td>
          <td class="severity-column" v-show="region.columns.severity.visible">
            <i class="material-icons warning-text" v-if="railObject.severity !== -1 && railObject.OperationModeId !== 5 && railObject.MonitorStatusId === 2">error</i>
            <i class="material-icons alarm-text" v-if="railObject.severity !== -1 && railObject.OperationModeId !== 5 && railObject.MonitorStatusId === 3">warning</i>
            <i class="material-icons maintenance-text" v-if="railObject.severity !== -1 && railObject.OperationModeId === 5">build</i>
            <i class="material-icons unknown-text" v-if="railObject.severity === -1">help</i>
          </td>
          <!-- <td class="objecttype-column" v-show="region.columns.objecttype.visible">{{railObject.code}}</td> -->
          <td class="date-column" v-show="region.columns.date.visible">{{ railObject.MeasurementDateTime | formatDate }}</td>
        </tr>
      </tbody>
    </table>
    <div class="noselect paging" v-if="region.open">
      <span class="buttons right">
        <a class="btn-flat" :disabled="region.listIndex === 0">
          <i class="material-icons" v-on:click="previousPage(region)">chevron_left</i>
        </a>
        <a class="btn-flat" :disabled="region.listIndex === Math.ceil(region.all.length/itemsPerPage) -1">
          <i class="material-icons" v-on:click="nextPage(region)">chevron_right</i>
        </a>
      </span>

      <span class="page-number">
        <span class="right">{{region.error.concat(region.warning).concat(region.maintenance).concat(region.normal).concat(region.unknown).length}}</span>
        <span class="right">of</span>
        <span class="right">{{Math.min(region.all.length, (region.listIndex*itemsPerPage)+1)}}-{{Math.min((region.listIndex*itemsPerPage)+itemsPerPage, region.all.length)}}</span>
      </span>

      <span class="page-info right">
        <span>{{ $t('views.alarmlist.rowsperpage') }}:
          <select v-model="itemsPerPageSelected">
            <option value="10">10</option>
            <option :value="region.error.concat(region.warning).concat(region.maintenance).concat(region.normal).concat(region.unknown).length">{{region.error.concat(region.warning).concat(region.maintenance).concat(region.normal).concat(region.unknown).length}}</option>
          </select>
        </span>
      </span>
    </div>
  </ul>
</div>
</template>

<script>
import Router from '../../router/index'
import UtilitiesService from '../../services/UtilitiesService'
import RailObjectService from '../../services/RailObjectService'
import DepartmentService from '../../services/DepartmentService'
import RegionService from '../../services/RegionService'
import ComplexService from '../../services/ComplexService'
import PossObjectCodeService from '../../services/PossObjectCodeService'

export default {
  name: 'hierarchy',
  data () {
    return {
      regions: [],
      itemsPerPage: 10,
      itemsPerPageSelected: 10
    }
  },
  beforeCreate: function () {
  },
  created: function () {
    var possObjectCodesByDataSourceCodeAndObjectCodeDescription = {}
    var possObjectCodes = JSON.parse(JSON.stringify(PossObjectCodeService.getPossObjectCodes()))
    possObjectCodes.forEach((possObjectCode) => {
      possObjectCodesByDataSourceCodeAndObjectCodeDescription[possObjectCode.DataSourceCode + '-' + possObjectCode.ObjectDescription] = possObjectCode
    })

    var regionsById = {}
    var departmentsById = {}
    var complexesById = {}
    var categorize = function (railObject, type) {
      switch (type) {
        case 'error':
          if (railObject.RegionId) {
            regionsById[railObject.RegionId].error.push(railObject)
          }
          if (railObject.DepartmentId) {
            departmentsById[railObject.DepartmentId].error.push(railObject)
          }
          if (railObject.ComplexId) {
            complexesById[railObject.ComplexId].error.push(railObject)
          }
          break
        case 'warning':
          if (railObject.RegionId) {
            regionsById[railObject.RegionId].warning.push(railObject)
          }
          if (railObject.DepartmentId) {
            departmentsById[railObject.DepartmentId].warning.push(railObject)
          }
          if (railObject.ComplexId) {
            complexesById[railObject.ComplexId].warning.push(railObject)
          }
          break
        case 'maintenance':
          if (railObject.RegionId) {
            regionsById[railObject.RegionId].maintenance.push(railObject)
          }
          if (railObject.DepartmentId) {
            departmentsById[railObject.DepartmentId].maintenance.push(railObject)
          }
          if (railObject.ComplexId) {
            complexesById[railObject.ComplexId].maintenance.push(railObject)
          }
          break
        case 'normal':
          if (railObject.RegionId) {
            regionsById[railObject.RegionId].normal.push(railObject)
          }
          if (railObject.DepartmentId) {
            departmentsById[railObject.DepartmentId].normal.push(railObject)
          }
          if (railObject.ComplexId) {
            complexesById[railObject.ComplexId].normal.push(railObject)
          }
          break
        case 'unknown':
          if (railObject.RegionId) {
            regionsById[railObject.RegionId].unknown.push(railObject)
          }
          if (railObject.DepartmentId) {
            departmentsById[railObject.DepartmentId].unknown.push(railObject)
          }
          if (railObject.ComplexId) {
            complexesById[railObject.ComplexId].unknown.push(railObject)
          }
          break
      }
    }
    var regions = JSON.parse(JSON.stringify(RegionService.getRegions()))
    var departments = JSON.parse(JSON.stringify(DepartmentService.getDepartments()))
    var complexes = JSON.parse(JSON.stringify(ComplexService.getComplexes()))

    regions.forEach((region) => {
      regionsById[region.RegionId] = region
      region.error = []
      region.warning = []
      region.maintenance = []
      region.all = []
      region.normal = []
      region.unknown = []
      region.Departments = []
      region.open = false
      region.tree = false
      region.listIndex = 0
      region.columns = {'date': {visible: true, sort: null}, 'severity': {visible: true, sort: null}, 'objecttype': {visible: true, sort: null}, 'path': {visible: true, sort: 'desc'}}
    })
    departments.forEach((department) => {
      departmentsById[department.DepartmentId] = department
      department.error = []
      department.warning = []
      department.maintenance = []
      department.normal = []
      department.unknown = []
      department.Complexes = []
      if (regionsById[department.RegionId] !== undefined) {
        regionsById[department.RegionId].Departments.push(department)
      }
      department.open = false
      department.tree = true
    })
    complexes.forEach((complex) => {
      complexesById[complex.ComplexId] = complex
      complex.error = []
      complex.warning = []
      complex.maintenance = []
      complex.normal = []
      complex.unknown = []
      departmentsById[complex.DepartmentId].Complexes.push(complex)
      complex.open = false
      complex.RailObjects = []
      complex.tree = true
    })

    this.railObjectsInWarningOrError = []
    RailObjectService.getRailObjects()
      .filter(r => r.DataSourceCode === 'WID' || r.DataSourceCode === 'ATD' || r.DataSourceCode === 'AKD' || r.DataSourceCode === 'CDD')
      .forEach((railObject) => {
        if (regionsById[railObject.RegionId] !== undefined) {
          regionsById[railObject.RegionId].all.push(railObject)
          if (railObject.ComplexId) {
            complexesById[railObject.ComplexId].RailObjects = complexesById[railObject.ComplexId].RailObjects || []
            complexesById[railObject.ComplexId].RailObjects.push(railObject)
          }

          if (railObject.StatusMeasurementDateTime) {
            railObject.StatusMeasurementDateTime = railObject.StatusMeasurementDateTime.substring(0, 19)
          }
          railObject.path = departmentsById[railObject.DepartmentId].Name + ' \\ ' + complexesById[railObject.ComplexId].Name + ' \\ ' + railObject.Name
          railObject.code = possObjectCodesByDataSourceCodeAndObjectCodeDescription[railObject.DataSourceCode + '-' + railObject.ObjectCodeDescription].Code

          if (railObject.OperationModeId === 5) {
            railObject.severity = 0
            categorize(railObject, 'maintenance')
          } else {
            switch (railObject.MonitorStatusId) {
              case 1:
                railObject.severity = 1
                categorize(railObject, 'normal')
                break
              case 2:
                railObject.severity = 2
                categorize(railObject, 'warning')
                this.railObjectsInWarningOrError.push(railObject)
                break
              case 3:
                railObject.severity = 3
                categorize(railObject, 'error')
                this.railObjectsInWarningOrError.push(railObject)
                break
              default:
                categorize(railObject, 'unknown')
                railObject.severity = -1
                break
            }
          }
        }
      })
    this.regions = UtilitiesService.sortByKey(regions, 'Name')
  },
  mounted: function () {
  },
  beforeDestroy: function () {
  },
  methods: {
    showDetail: function (railObject) {
      if (railObject.DataSourceCode === 'WID') {
        Router.push({
          name: 'Switch',
          params: {
            id: railObject.RailObjectId,
            measurementId: railObject.LastMeasurementId
          },
          props: true
        })
      }
      if (railObject.DataSourceCode === 'ATD') {
        Router.push({
          name: 'AxleCounter',
          params: {
            railobjectid: railObject.RailObjectId
            // passedMeasurementId: railObject.LastMeasurementId
          }
        })
      }
      if (railObject.DataSourceCode === 'AKD') {
        Router.push({
          name: 'AxleShunt',
          params: {
            id: railObject.RailObjectId
          }
        })
      }
      if (railObject.DataSourceCode === 'CDD') {
        Router.push({
          name: 'MixedSignals',
          params: {
            railobjectid: railObject.RailObjectId
          },
          props: true
        })
      }
    },
    nextPage: function (region) {
      region.listIndex++
    },
    previousPage: function (region) {
      region.listIndex--
    },
    toggleColumnVisibility: function (name) {
      this.columns[name].visible = !this.columns[name].visible
    },
    toggleFilterMenu: function () {
      this.filterMenu = !this.filterMenu
    },
    toggleOpen: function (region) {
      region.open = !region.open
      if (region.open) {
        this.toggleSort('path', region)
      }
    },
    toggleSort: function (name, region) {
      switch (name) {
        case 'severity':
          region.columns.date.sort = null
          region.columns.objecttype.sort = null
          region.columns.path.sort = null
          break
        case 'objecttype':
          region.columns.severity.sort = null
          region.columns.date.sort = null
          region.columns.path.sort = null
          break
        case 'path':
          region.columns.severity.sort = null
          region.columns.objecttype.sort = null
          region.columns.date.sort = null
          break
        case 'date':
          region.columns.severity.sort = null
          region.columns.objecttype.sort = null
          region.columns.path.sort = null
          break
      }

      if (region.columns[name].sort === 'asc') {
        region.columns[name].sort = 'desc'
      } else if (region.columns[name].sort === 'desc') {
        region.columns[name].sort = 'asc'
      } else {
        region.columns[name].sort = 'desc'
      }
      this.sortList(region)
    },
    sortList: function (region) {
      if (region.columns.severity.sort === 'asc') {
        region.sorted = UtilitiesService.sortByKey(region.all, 'severity')
      } else if (region.columns.severity.sort === 'desc') {
        region.sorted = UtilitiesService.sortByKey(region.all, 'severity').reverse()
      } else if (region.columns.objecttype.sort === 'asc') {
        region.sorted = UtilitiesService.sortByKey(region.all, 'code')
      } else if (region.columns.objecttype.sort === 'desc') {
        region.sorted = UtilitiesService.sortByKey(region.all, 'code').reverse()
      } else if (region.columns.path.sort === 'asc') {
        region.sorted = UtilitiesService.sortByKey(region.all, 'path')
      } else if (region.columns.path.sort === 'desc') {
        region.sorted = UtilitiesService.sortByKey(region.all, 'path').reverse()
      } else if (region.columns.date.sort === 'asc') {
        region.sorted = UtilitiesService.sortByKey(region.all, 'MeasurementDateTime')
      } else if (region.columns.date.sort === 'desc') {
        region.sorted = UtilitiesService.sortByKey(region.all, 'MeasurementDateTime').reverse()
      }
    }
  },
  watch: {
    itemsPerPageSelected: {
      handler: function (itemsPerPage) {
        this.itemsPerPage = parseInt(itemsPerPage)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.alarm-list-content > .title {
  padding-top: 16px;
  padding-left: 22px;
}

.alarm-list-content .filter-content,
.alarm-list-content .search-content,
.alarm-list-content .tab-content {
  position: relative;
  padding-left: 22px;
  padding-right: 22px;
  width: 100%;
}

.tab-content {
  display: inline-block;
}

.filter-content > .title {
  margin-top: 20px;
  font-size: 14px;
  font-family:Roboto;
  font-weight: 600;
  font-style: normal;
  line-height: normal;
}

.filters tr {
  border-bottom: none;
}

.filters td span {
  color: rgba(0, 0, 0, 0.87);
}

.filters td:first-child {
  color: rgba(0, 0, 0, 0.4);
}

.filters td, filters th {
  padding: 15px 0px;
}

.search tr td:first-child {
  width: 12%;
  font-size: 14px;
  font-family:Roboto;
  font-weight: 600;
  font-style: normal;
}

.search-placeholder {
  height: 44px;
  width: 344px;
  margin-top: 7px;
  margin-bottom: 7px;
  background-color: #fff;
  position: relative;
  padding-left: 10px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.search-placeholder input {
  width: 280px !important;
  position: absolute;
  height: 44px !important;
  margin: 0px !important;
  border-bottom: none !important;
}

.search-placeholder i {
    height: 44px;
    line-height: 44px;
    color: rgba(0, 0, 0, 0.54);
}

.search tr {
  border: none;
}

.list-region {
  font-size: 20px;
}

.list-department {
  font-size: 18px;
  margin-left: 20px;
}

.list-complex {
  font-size: 16px;
  margin-left: 40px;
}

.list-railobject {
  font-size: 14px;
  margin-left: 86px;
  color: rgba(0, 0, 0, 0.87);
  list-style-type: disc !important;
}

.list-region > .material-icons,
.list-department > .material-icons,
.list-complex > .material-icons {
  top: 4px !important;
  position: relative;
}

.railobject-icon > .material-icons {
  top: 3px;
  font-size: 20px;
  position: relative;
  margin-left:5px;
}

.error-count,
.warning-count,
.maintenance-count,
.total-count,
.railobject-type {
  margin-left: 10px;
}

.total-count {
  line-height: 20px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.railobject-type {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.info span {
  display: inline-block;
}

.info span i {
  float: right;
  margin: 0 5px;
}

.extended-opacity {
  opacity: 0.56;
}

.tab-page ul {
  margin: 0px 0px;
}

.grid-option {
  top: 6px;
  position: relative;
  left: 5px;
}

.paging {
  height: 50px;
  width: calc(100% - 30px);
  left: 30px;
  line-height: 50px;
  position: relative;
  border-top: 1px solid rgba(0, 0, 0, 0.4);
}

.paging .page-number {
  margin-right: 30px;
}

.paging .page-number span {
  padding-right: 5px;
}

.paging .page-info {
  margin-right: 40px;
}

.paging .page-info select {
  display: inline-block;
  padding: 0px;
  height: 30px;
  width: 50px;
}

.paging .buttons .btn-flat[disabled] {
  background-color: #fff !important;
}

.hierarchy-list {
  position: relative;
  width: calc(100% - 30px);
  left: 30px;
}

.hierarchy-list thead tr {
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
}

.hierarchy-list th, .hierarchy-list td {
  padding: 5px 5px;
  height: 36px;
}

.hierarchy-list .material-icons {
  font-size: 20px;
}

.col-severity {
  width: 60px;
  text-align: center;
}

.col-datetime {
  width: 80px;
  text-align: center;
}

.severity-column {
  width: 80px;
  text-align: center;
}

.objecttype-column {
  width: 150px;
  text-align: center;
}

.date-column {
  width: 200px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/_Hierarchy.vue